export default "__VITE_ASSET__C_LCPQd8__"